export const JOIN_MAILING_LIST_START = 'coming-soon/JOIN_MAILING_LIST_START';
export const JOIN_MAILING_LIST_COMPLETED = 'coming-soon/JOIN_MAILING_LIST_COMPLETED';
export const JOIN_MAILING_LIST_FAILED = 'coming-soon/JOIN_MAILING_LIST_FAILED';

export const FETCH_DATA_START = 'coming-soon/FETCH_DATA_START';
export const FETCH_DATA_COMPLETED = 'coming-soon/FETCH_DATA_COMPLETED';
export const FETCH_DATA_FAILED = 'coming-soon/FETCH_DATA_FAILED';
